var map = {
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./design/design.module": [
		"./src/app/design/design.module.ts",
		"design-design-module"
	],
	"./help/help.module": [
		"./src/app/help/help.module.ts",
		"help-help-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts"
	],
	"./orders/orders.module": [
		"./src/app/orders/orders.module.ts",
		"orders-orders-module~shop-shop-module",
		"orders-orders-module"
	],
	"./shop/shop.module": [
		"./src/app/shop/shop.module.ts",
		"orders-orders-module~shop-shop-module",
		"shop-shop-module"
	],
	"./variants/variants.module": [
		"./src/app/variants/variants.module.ts",
		"variants-variants-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;